import { Image as ApiImage, ImageSize as ApiImageSize, ImageTypeEnum } from '@/gen/api';
import {
  Image as ImageModel,
  ImageSize as ImageSizeModel,
  type ImageType as ImageTypeType,
} from '@/models/Image';

const toImageType = (apiImageType: ImageTypeEnum): ImageTypeType => {
  const normalized = apiImageType.toLowerCase() as ImageTypeEnum;

  switch (normalized) {
    case 'original':
      return 'ORIGINAL';
    case 'thumbnail':
      return 'THUMBNAIL';
    case 'large':
      return 'LARGE';
    case 'small':
      return 'SMALL';
    default:
      return 'UNKNOWN';
  }
};

const toImageSize = (apiImageSize: ApiImageSize): ImageSizeModel => {
  return {
    ...apiImageSize,
    type: toImageType(apiImageSize.type),
  };
};

export const toImage = (apiImage: ApiImage): ImageModel => {
  return {
    ...apiImage,
    type: toImageType(apiImage.type),
    sizes: apiImage.sizes?.map(toImageSize) || [],
  };
};
